var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBorder1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64.11 64.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.47,
    y: 16.62,
    width: 50.92,
    height: 30.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64.11,
    height: 64.11
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-3",
    d: "M59.07,22.11l-.63-.52-.28-.23a22.68,22.68,0,0,0-14-4.57,30.13,30.13,0,0,0-17.91,6.15A32.75,32.75,0,0,0,15,38.54v-6.9a2.68,2.68,0,0,0-.81-2,2.73,2.73,0,0,0-2-.82H9.69a.42.42,0,0,0-.42.42V46.9a.42.42,0,0,0,.42.42H20.15a.42.42,0,0,0,.41-.36,35.29,35.29,0,0,1,9.2-19.19,23.6,23.6,0,0,1,28.84-5,.43.43,0,0,0,.55-.13.4.4,0,0,0-.08-.54Zm-9.8-3.44c-.68-.05-1.37-.09-2.06-.09A25.7,25.7,0,0,0,28.8,26.84,36.6,36.6,0,0,0,19.37,46H10.61V30.2H12.2a1.39,1.39,0,0,1,1,.42,1.37,1.37,0,0,1,.42,1v9.67a.92.92,0,0,0,.8.9.91.91,0,0,0,1-.67c4.28-16.09,17.88-23.42,28.7-23.42a23.5,23.5,0,0,1,5.12.55ZM14.79,27.46V25.72a2.76,2.76,0,0,0-.81-2,2.47,2.47,0,0,0-1.85-.82H9.06a.43.43,0,0,0-.42.42v.24a4.54,4.54,0,0,0,.94,3.35,3.86,3.86,0,0,0,2.83,1h2A.42.42,0,0,0,14.79,27.46Zm-1.33-.92H12.41A2.59,2.59,0,0,1,10.52,26,2.56,2.56,0,0,1,10,24.25h2.15a1.12,1.12,0,0,1,.91.42,1.45,1.45,0,0,1,.42,1.06Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBorder1);
export default __webpack_public_path__ + "static/media/CheckBorder_1.fb9e4d0a95cef82de95b0f8cfb6a194c.svg";
export { ForwardRef as ReactComponent };